<template>
  <div class="chart-wrapper">
    <ul class="list-none elsa-chart">
      <li v-for="item in series" :key="item.name" class="flex justify-center">
        <p class="w-p-50 flex content-center skill-name">{{ $t('charts.skill_name', [item.name]) }}</p>
        <div class="w-p-50">
          <apexchart type="radialBar" width="100" height="80" :options="chartOptions" :series="item.data" class="skill-chart" />
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { toFixed, round } from '../../../utils/ramda-utils'
import { pathOr, compose, converge, reduce, head, identity, max, prop, map, propOr, over, lensProp } from 'ramda'
import { BLUE } from '../../../constants/charts'

export default {
  props: {
    series: {
      type: Array,
      default: () => []
    },
    labels: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    updatedSeries() {
      return compose(map(over(lensProp('name'), (name) => this.$t(`charts.${name}`))), propOr([], 'series'))(this)
    },
    dataSeries: pathOr([], ['series', 0, 'data']),
    maxValue: compose(converge(reduce(max), [head, identity]), prop('dataSeries')),
    numberOfTicks() {
      const ticks = this.maxValue < 6 ? round(this.maxValue) : 6
      return ticks
    },
    chartOptions() {
      return {
        chart: {
          type: 'radialBar'
        },
        plotOptions: {
          radialBar: {
            hollow: {
              size: '40%'
            },
            track: {
              background: '#453C9C'
            },
            dataLabels: {
              name: {
                show: false
              },
              value: {
                offsetY: 3,
                color: '#121131',
                fontSize: '12px',
                fontWeight:  500,
                fontStyle: 'normal',
                fontFamily: 'SF Pro Display',
                formatter: function (val, opts) {
                  return `${(Math.round(val * 100) / 100).toFixed(0)}%`
                }
              }
            }
          }
        },
        fill: {
          type: 'gradient',
          gradient: {
            shade: 'dark',
            type: 'horizontal',
            shadeIntensity: 0.5,
            gradientToColors: ['#1cf0db'],
            inverseColors: true,
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 100]
          }
        },
        stroke: {
          lineCap: 'round'
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.line-chart-mobile {
  min-width: 600px;
}

.skill-chart {
  margin-top: -10px;
  margin-bottom: -10px;
}

// .elsa-chart {
//   display: grid;
//   grid-template-columns: 50% 50%;
// }

.chart-wrapper {
  min-height: 200px;
  display: flex;
  flex-direction: column;
}

.skill-name{
  font-size: 16px;
  font-weight: 400;
}
</style>
